import { useStorage } from '@vueuse/core'

export const useUserStore = defineStore(
  'user',

  () => {
    const token: Ref<string | null | undefined> = useStorage('token', undefined)
    function setToken(t: string | null) {
      token.value = t
    }

    const userInfo = ref()
    function setUserInfo(user: any) {
      userInfo.value = user
    }

    const companyInfo = ref()
    function setCompanyInfo(company: any) {
      companyInfo.value = company
    }

    function clearLoginInfo() {
      setToken(null)
      setUserInfo(undefined)
      setCompanyInfo(undefined)
    }

    return {
      token,
      setToken,
      userInfo,
      setUserInfo,
      companyInfo,
      setCompanyInfo,
      clearLoginInfo,
    }
  },

  {
    persist: {
      pick: ['userInfo', 'companyInfo'],
    },
  },
)
